module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-02@2x.46fcdcc.webp";